<template>
  <div class="course-grade-view">
    <div ref="view" class="grid">
      <div class="shell" :style="{'left': shell.x, 'top' : shell.y, 'background-color': shell.color}"></div>
      <img ref="arrow" class="arrow" :src="shotArrow" />
      <!-- :class="'grade' + (item.unlocked ? ' unlock' : '')" -->
      <div v-for="item in courses" :key="item.id" :class="'course' + (item.unlocked ? '' : ' lock')" @click="courseClick(item)" :title="item.unlocked ? '' : '未解锁'"
        :style="{'left': item.x + 'px', 'top' : item.y + 'px', 'background-color': item.color}">{{item.name}}</div>
    </div>
  </div>
</template>

<script>
import shotArrow from 'assets/image/shot-arrow-80.png'
let colors = ['rgba(255, 0, 0, 0.5)', 'rgba(255, 165, 0, 0.5)', 'rgba(255, 255, 0, 0.5)', 'rgba(0, 255, 0, 0.5)', 'rgba(0, 255, 255, 0.5)', 'rgba(0, 0, 255, 0.5)', 'rgba(128, 0, 128, 0.5)']
export default {
  name: 'courseUnit',
  data () {
    return {
      id: this.$route.params.id,
      courses: [],
      arrowCenter: null,
      shotArrow,
      radius: 0,
      shell: {x: '50%', y: '50%'}
    }
  },
  created () {
    this.getCourses()
  },
  mounted () {
    this.setMouseFollow()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    getCourses () {
      // 获取面包屑导航
      this.$store.dispatch('setCourseNav', { id: this.id, idType: 2 })
      // 获取课程数据
      this.$store.dispatch('setLoading')
      this.$http.get('course/courses?gradeId=' + this.id)
        .then((response) => {
          this.$nextTick(() => {
            this.courses = response
            this.setCoursesPosition(true)
          })
        })
        .catch(() => {
          this.$message.error('加载课程列表失败，请重试')
        })
        .then(() => {
          this.$store.dispatch('setLoading', false)
        })
    },
    resize () {
      this.arrowCenter = this.getOffset(this.$refs.arrow)
      this.setCoursesPosition()
    },
    setMouseFollow () {
      this.arrowCenter = this.getOffset(this.$refs.arrow)
      this.$refs.view.addEventListener('mousemove', (e) => {
        let mouse = this.getMousePosition(e)
        let rolation = Math.atan2(this.arrowCenter.y - mouse.y, mouse.x - this.arrowCenter.x)
        this.$refs.arrow.style.transform = 'translate(-50%, -50%) rotate(' + (-180 * rolation / Math.PI) + 'deg)'
      })
    },
    setCoursesPosition (first) {
      let left = this.$refs.arrow.offsetLeft
      let top = this.$refs.arrow.offsetTop
      // 半径
      this.radius = (left < top ? left : top) - 30 - 20
      this.radius = this.radius < 150 ? 150 : this.radius
      // 角度
      let angle = 360 / this.courses.length
      let subCount = Math.round(this.courses.length / 4)
      // 求得相对于圆心的水平距离和垂直距离
      let temp = this.courses
      temp.forEach((item, i) => {
        if (first) {
          item.angle = angle * (i - subCount) * Math.PI / 180
          item.color = item.unlocked ? colors[Math.floor(Math.random() * 7)] : 'rgba(153, 153, 153, 0.5)'
        }
        let eleX = Math.cos(item.angle) * this.radius
        let eleY = Math.sin(item.angle) * this.radius
        item.x = left + eleX
        item.y = top + eleY
      })
      // 改变courses重新渲染页面
      this.courses = null
      this.courses = temp
    },
    getMousePosition (e) {
      e = e || window.event
      let scrollX = document.documentElement.scrollLeft || document.body.scrollLeft
      let scrollY = document.documentElement.scrollTop || document.body.scrollTop
      let x = e.pageX || e.clientX + scrollX
      let y = e.pageY || e.clientY + scrollY
      return { 'x': x, 'y': y }
    },
    getOffset (obj) {
      let offset = { x: 0, y: 0 }
      while (obj) {
        offset.x += obj.offsetLeft
        offset.y += obj.offsetTop
        obj = obj.offsetParent
      }
      return offset
    },
    courseClick (course) {
      if (!course.unlocked) {
        return false
      }
      let left = this.$refs.arrow.offsetLeft
      let top = this.$refs.arrow.offsetTop
      let distance = this.radius / 10
      let movedDistance = 0
      let interval = setInterval(() => {
        let temp = {}
        if (movedDistance >= this.radius) {
          clearInterval(interval)
          temp.x = '50%'
          temp.y = '50%'
          temp.color = null
          this.shell = temp
          this.$router.push({ path: '/course/study/' + course.id })
          return
        }
        movedDistance += distance
        let eleX = Math.cos(course.angle) * movedDistance
        let eleY = Math.sin(course.angle) * movedDistance
        temp.x = left + eleX + 'px'
        temp.y = top + eleY + 'px'
        temp.color = course.color.replace(', 0.5', '')
        this.shell = temp
      }, 30)
    }
  },
  watch: {
    '$route.params.id': function (newId) {
      this.id = newId
      this.getCourses()
    }
  }
}
</script>

<style lang="scss">
.course-grade-view {
  position: relative;
  height: 100%;
  min-height: 300px !important;
  .grid {
    position: relative;
    height: 100%;
  }
  .arrow, .shell {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .shell {
    height: 30px;
    width: 30px;
    border-radius: 50%;
  }
  .course {
    // border: 1px solid #000;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    line-height: 40px;
    text-align: center;
    position: absolute;
    transform: translate(-50%, -50%);
    cursor: pointer;
    background-image: url('../../assets/image/shell.png');
    background-size: 100%;
    font-size: 14px;
    z-index: 2;
    &.lock {
      cursor: not-allowed;
    }
    &:hover {
      z-index: 3;
      height: 45px;
      width: 45px;
      line-height: 45px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/grade.vue